.alert.cookie-message {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: $zindex-fixed;
	background-color: #F2F4F8;
	padding: 26px 0;

	.container {
		padding: 0 35px;

		span.svg-icon {
			svg {
				@include svg-format(66px, 55px, #3D3D3D);
			}
		}
		
		> p > a {
			color: $secondary;
		}
	}
}

.kdx-cookie {
	background-color: #FFF;
	box-shadow: 0px -4px 14px rgba(0, 37, 64, 0.10);

	> .container {
		display: flex;
		align-items: center;
		justify-content: center;

		img{
			max-width: 115px;
			margin: 0 10px;
		}

		> * {
			flex: 1 0 auto;
			@include text-size(16);


			&:nth-child(2) {
				padding: 0 50px 0 31px;
				max-width: 75%;
			}

			&:last-child {
				padding-right: 0;
				text-align: center;
			}
		}
	}

	p {
		margin: 0;
		padding: 0;
		color: #282828;
	}

	.cookie-links {
		@include row-cols(1);
		max-width: 250px;

		> :first-child {
			margin: 0 0 10px;
		}
	}
}

@include media-breakpoint-down(md) {
	.alert.cookie-message {
		.container {
			padding: 0 35px;
			max-width: 620px;

			span.svg-icon {
				svg {
					@include svg-format(57px, 55px, #3D3D3D);
				}
			}

			> * {
				padding: 0;
				
			}

			p {
				max-width: 100%;
				@include text-size(14);
				@include line-height(22);
				text-align: center;
				padding: 18px 0;
			}

			.cookie-links { min-width: 100%; }

			img {
				display: none;
			}
			
			
		}
	}

	.kdx-cookie {
		> .container {
			flex-direction: column;
			padding: 0 35px;
		}

		.cookie-links {
			padding: 0;
			margin: 15px 0 0;

			> :first-child { 
				margin-bottom: 0;
				min-width: 100%
			}
		}
	}
}